// eslint-disable-next-line
import QuoteIcon from '!!raw-loader!@img/icons/quote.svg';
import InlineEditor from '@UI/editor/InlineEditor';
import type { RootState } from '@generalTypes/rootStateTypes';
import type { QuoteNode } from '@newStore/documentUI/documentUITypes';
import { selectAppliedNodeConfig } from '@newStore/documentUI/nodeTypeConfigSelectors';
import { useSelector } from 'react-redux';
import './QuoteRow.scss';
import { getPlaceHolderLabel } from '../../contentRowHelpers';

const QuoteRow: React.FC<{ contentNode: QuoteNode }> = ({ contentNode }) => {
  const nodeTypeConfig = useSelector((state: RootState) =>
    selectAppliedNodeConfig(state, contentNode.href),
  );

  return (
    <div className="quote-row">
      <span className="quote-icon" dangerouslySetInnerHTML={{ __html: QuoteIcon }} />
      <InlineEditor
        initial={contentNode.text}
        field="html"
        placeholder={getPlaceHolderLabel(nodeTypeConfig, 'html')}
        skey={contentNode.key}
        href={contentNode.href}
      />
    </div>
  );
};

export default QuoteRow;
